import {
    type FC
} from "react";
import {
    Pressable,
    Image,
    View
} from "react-native";
import type IAttachmentGridTileProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useInteractionState
} from "../../../../helpers/interaction";
import AttachmentMediaBadge from "../mediaBadge";
import StateLayer from "../../../stateLayer";

const AttachmentGridTile: FC<IAttachmentGridTileProps> = ({
    customTheme,
    moreText,
    onPress,
    source,
    label,
    index
}) => {
    const {
        shapeConfigs,
        radiuses,
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        interactionHandlers,
        isFocusVisible,
        isHovered,
        isPressed
    } = useInteractionState({
    });

    const {
        container: containerDynamicStyle,
        overlay: overlayDynamicStyle,
        surface: surfaceDynamicStyle,
        scrim: scrimDynamicStyle
    } = useStyles({
        isFocusVisible,
        shapeConfigs,
        radiuses,
        borders,
        colors
    });

    const handlePress = () => {
        onPress?.(index);
    };

    return <Pressable
        {...interactionHandlers}
        accessibilityLabel={label}
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
        onPress={handlePress}
        role="button"
    >
        <View
            style={[
                stylesheet.surface,
                surfaceDynamicStyle
            ]}
        >
            <Image
                style={stylesheet.fill}
                resizeMode="cover"
                aria-hidden={true}
                source={source}
            />
            {
                moreText ?
                    <View
                        style={[
                            stylesheet.center,
                            scrimDynamicStyle
                        ]}
                    >
                        <AttachmentMediaBadge
                            customTheme={customTheme}
                        >
                            {moreText}
                        </AttachmentMediaBadge>
                    </View>
                :
                    null
            }
            <View
                style={[
                    stylesheet.overlay,
                    overlayDynamicStyle
                ]}
            >
                <StateLayer
                    borderRadius={radiuses.xs}
                    customTheme={customTheme}
                    isHovered={isHovered}
                    isPressed={isPressed}
                    isSquircle={true}
                />
            </View>
        </View>
    </Pressable>;
};
export default AttachmentGridTile;
